import { render, staticRenderFns } from "./courseScheduleDisplay.vue?vue&type=template&id=6b74a640&scoped=true"
import script from "./courseScheduleDisplay.vue?vue&type=script&lang=js"
export * from "./courseScheduleDisplay.vue?vue&type=script&lang=js"
import style0 from "./courseScheduleDisplay.vue?vue&type=style&index=0&id=6b74a640&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b74a640",
  null
  
)

export default component.exports